import { isValidLegalName, LEGAL_NAME_FORMAT_MESSAGE } from './legalName'
import { isValidLegalEntityInn } from './inn'

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export type RegisterFormField =
  | 'email'
  | 'password'
  | 'inn'
  | 'legalName'
  | 'tradeName'
  | 'consentOffer'
  | 'productTypeIds'

export type RegisterFormFieldErrors = Partial<Record<RegisterFormField, string>>

export type RegisterFormValues = {
  orgType: 'buyer' | 'supplier'
  email: string
  password: string
  inn: string
  legalName: string
  tradeName: string
  consentOffer: boolean
  productTypeIds: number[]
}

export const hasRegisterFormErrors = (errors: RegisterFormFieldErrors): boolean =>
  Object.keys(errors).length > 0

export const validateRegisterForm = (values: RegisterFormValues): RegisterFormFieldErrors => {
  const errors: RegisterFormFieldErrors = {}

  if (!values.email.trim()) {
    errors.email = 'Введите корпоративную почту'
  } else if (!EMAIL_RE.test(values.email.trim())) {
    errors.email = 'Введите корректный email, например zakupki@company.ru'
  }
  if (!values.password) {
    errors.password = 'Введите пароль'
  } else if (values.password.length < 8) {
    errors.password = 'Пароль должен содержать не менее 8 символов'
  }
  if (!values.inn.trim()) {
    errors.inn = 'Введите ИНН'
  } else if (!isValidLegalEntityInn(values.inn.trim())) {
    errors.inn = 'ИНН юридического лица должен содержать 10 цифр'
  }
  if (!values.legalName.trim()) {
    errors.legalName = 'Введите юридическое название'
  } else if (!isValidLegalName(values.legalName)) {
    errors.legalName = LEGAL_NAME_FORMAT_MESSAGE
  }
  if (!values.tradeName.trim()) {
    errors.tradeName = 'Введите торговое название'
  }
  if (!values.consentOffer) {
    errors.consentOffer = 'Нужно принять публичную оферту'
  }
  if (values.orgType === 'supplier') {
    if (values.productTypeIds.length === 0) {
      errors.productTypeIds = 'Выберите от 1 до 3 категорий товаров'
    } else if (values.productTypeIds.length > 3) {
      errors.productTypeIds = 'Не более 3 категорий товаров'
    }
  }

  return errors
}
